import styles from "./styles.mobile.module.scss";
import { ReactNode } from "react";
import classNames from "classnames";
import { WebSearchBar } from "../../CustomComponents/WebSearchBar";
import { FacilitySelector } from "../../CustomComponents/FacilitySelector";
import { useAppSelector } from "../../../hooks/redux";
import { useChangeFacility } from "../../../hooks/useChangeFacility";
import { useVitalsAIMode } from "../../../hooks/useVitalsAIMode";
import { isHomeHealthExternalUser } from "../../../constants/sso";

export interface IProps {
  menuIcon?: ReactNode;
  onClickSearch: () => void;
  title?: string;
  hideFacilitySelector?: boolean;
  hideSearchBar?: boolean;
  leftOfFacilitySelector?: ReactNode;
}

export const HeaderWeb: FC<IProps> = ({
  onClickSearch,
  menuIcon,
  title,
  hideFacilitySelector = false,
  hideSearchBar = false,
  leftOfFacilitySelector,
}) => {
  const isVitalsAIMode = useVitalsAIMode();
  const { clinicList, userClinic, user } = useAppSelector((state) => ({
    clinicList: state.clinic.clinicList,
    userClinic: state.clinic.userClinic,
    user: state.auth.user,
  }));

  const changeFacility = useChangeFacility();

  const isHomeHealthExternal = isHomeHealthExternalUser(
    user?.groups,
    user?.email
  );

  return (
    <>
      <div
        className={classNames(styles.container, {
          [styles.containerTransparent]: hideSearchBar,
        })}
      >
        {hideSearchBar ? (
          // Empty flex spacer so FacilitySelector remains right-aligned
          <div className={classNames(styles.searchBarCon)} />
        ) : !isVitalsAIMode && !isHomeHealthExternal ? (
          <div className={classNames(styles.searchBarCon)}>
            <div className={styles.searchCon} id="global-search">
              <WebSearchBar onSearchClick={onClickSearch} />
            </div>
          </div>
        ) : (
          // Show only the menu icon when in vitals AI mode
          <div className={classNames(styles.searchBarCon)}>
            <div className={styles.searchCon}>{menuIcon}</div>
          </div>
        )}
        {!hideFacilitySelector && (
          <div className={classNames(styles.searchBarCon)}>
            <div
              className={classNames(styles.facilitySelectorRow, {
                [styles.facilitySelectorRowExternal]: isHomeHealthExternal,
              })}
              id="global-search"
            >
              {leftOfFacilitySelector}
              <FacilitySelector
                clinicList={clinicList}
                selectedClinic={userClinic}
                onFacilityChange={changeFacility}
              />
            </div>
          </div>
        )}
        {!isVitalsAIMode && !isHomeHealthExternal && menuIcon && (
          <div className="d-flex align-items-center">{menuIcon}</div>
        )}
      </div>
      {title && (
        <h5 className={styles.heading} id="main-heading">
          {title}
        </h5>
      )}
    </>
  );
};
